// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1k96x","left":"styles_left__1IjNx"};